import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0 16px',
    color: 'white',
    gap: 16,
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    padding: 32,
  },
  paper: {
    maxWidth: theme.breakpoints.values.xl,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    padding: 16,
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'space-between',
  },
  grid: {
    padding: 16,
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
    justifyItems: 'center',

    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '1fr 1fr',
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '1fr 1fr 1fr',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
    },
  },
}));
